import * as React from "react";
import * as R from "ramda";
import { Form } from "react-final-form";
import { Col, Row, Glyphicon } from "react-bootstrap";
import TipoAgrupadora from "../../../general/componentes/TipoAgrupadora";
import { connect } from "react-redux";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import TextoInput from "../../../general/componentes/TextoInput";
import TablaDni from "./TablaDni";
import TablaParametros from "./TablaParametros";
import TablaTelefono from "./TablaTelefono";
import { Datos} from "../../../documentos/modelo/Documento";
import { FiltroAgrupadora } from "../modelo/Agrupadora";
import {consultarParametros, obtenerXLSParametros}from "../modulos/parametrosActions";



class Consultar extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            visualizarTabla: false,
            filtroAgrupadora: {},
            visualizarInput: false
        };
    }

    render() {

        const { documentos, estadoConsulta, estadoXLS, paginas, tamanoPagina, paginaActual } = this.props;
        const { visualizarTabla, visualizarInput } = this.state;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Reporte Agrupadoras</h1>

                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar Agrupadoras</h3>
                                    </div>
                                    <div className={"card-body"}>

                                        {this.renderFiltros(values, visualizarInput)}

                                        <Row className="form-group">
                                            <Col sm={2}>
                                                {documentos.length > 1 && visualizarTabla &&
                                                    <a onClick={this.obtenerXLS} className="btns btn-success">
                                                        <Glyphicon className={"save-file"}
                                                            glyph={"save-file"} /> Exportar XLS

                                                </a>}
                                            </Col>
                                            <Col smOffset={6} sm={1}>
                                                <button type="button" className="btns btns-link"
                                                    onClick={form.reset}
                                                    disabled={submitting}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                    disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderXLS(estadoXLS)}
                    {this.renderDocumentos(documentos, estadoConsulta, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderFiltros(values: any, visualizarInput: boolean) {
        return (
            <div>
                <Row className="form-group">
                    <Col sm={3}>
                        <label>Tipo Parametro</label>
                         <TipoAgrupadora name="tipoParametro" excluir={["DNI_REPRESENTANTE_LEGAL","CORREO","ACT_ECONOMICA"]} />
                    </Col>
                    <Col sm={3}>
                        <label htmlFor="valor">Valor</label>
                        <TextoInput name="valor" id="valor_input_agrupadora" placeholder="Ingrese un valor" disabled={!visualizarInput} />
                    </Col>
                </Row>
            </div>
        );
    }

    renderXLS = (estado: REQUEST) => {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error generando el XLS"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={"Reporte generado exitosamente"} />
                    </span>
                );
            default:
                return false;
        }
    };

    renderDocumentos(documentos: Array<Datos>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        const { visualizarTabla } = this.state;
        if (visualizarTabla) {
            switch (estado) {
                case REQUEST.ERROR:
                    return <Mensaje type={"danger"} mensaje={"Se ha presentado un error obteniendo el reporte"} />;
                case REQUEST.PENDING:
                    return <DotLoader size={25} />;
                case REQUEST.SUCCESS:
                    if (!documentos || !documentos.length) {
                        return (
                            <span>
                                <Mensaje type={"danger"} mensaje={"No hemos encontrado documentos :("}/>
                            </span>
                        );
                    } else {
                        switch (this.state.filtroAgrupadora.parametro) {
                            case 'DNI_EMPRESA': {
                                return (
                                    <span>
                                        <TablaDni 
                                            estados={documentos}
                                            filtroDocumento={this.filtros()}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual}
                                            consultaPaginada={this.consultaPaginada}
                                            />
                                    </span>
                                );
                            }
                            case 'TELEFONO': {
                                return (
                                    <span>
                                        <TablaTelefono
                                            estados={documentos}
                                            filtroDocumento={this.filtros()}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual}
                                            consultaPaginada={this.consultaPaginada}
                                            />
                                    </span>
                                );
                            }
                            default: {
                                return (
                                    <span>
                                        <TablaParametros
                                            estados={documentos}
                                            filtroDocumento={this.filtros()}
                                            paginas={paginas} 
                                            tamanoPagina={tamanoPagina}
                                            paginaActual={paginaActual}
                                            consultaPaginada={this.consultaPaginada}
                                            />
                                    </span>
                                );
                            }
                        }
                    }
                default:
                    return false;
            }
        } else
            return false;
    }

    

    filtros(): FiltroAgrupadora {
        switch (this.state.filtroAgrupadora.tipoParametro) {
            case 'DNI_EMPRESA': {
                return { 
                    dni: this.state.filtroAgrupadora.dni,
                };
            }
            case 'TELEFONO': {
                return { 
                    phone: this.state.filtroAgrupadora.phone,
                };
            }
            default: {
                return { 
                    dni: this.state.filtroAgrupadora.dni,
                    phone: this.state.filtroAgrupadora.phone
                };
            }
        }
    }

    consultaPaginada = (filtro: FiltroAgrupadora) => {
        this.props.dispatch(consultarParametros(filtro));
    };
    

    onSubmit = values => {
        const parametro = values.tipoParametro ? values.tipoParametro.valueOf() : "";
        const valor = values.valor ? values.valor.valueOf() : "";
        const estado = values.estado ? values.estado.valueOf() : "";
        const pagina = 0;

        const filtro: FiltroAgrupadora = {
            parametro: parametro,
            valor: valor,
            estado: estado,
            registrosPorPagina: this.props.tamanoPagina,
            pagina: pagina
        };
        this.setState({ filtroAgrupadora: filtro, visualizarTabla: true });
        this.props.dispatch(consultarParametros(filtro));
    };


    limpiar = () => {
        this.setState({
            filtroAgrupadora: {}
        });
    };

    obtenerXLS = () => {
        this.props.dispatch(obtenerXLSParametros(this.state.filtroAgrupadora));
    }

    validate = values => {
        switch (values.tipoParametro) {
            case 'DNI_EMPRESA': {
                return this.validarFiltroDni(values);
            }
            case 'TELEFONO':{
                return this.validarFiltroTelefono(values);
            }
            case 'ALL':{
                return this.validarFiltroTodos(values);
            }
            default: {
                return this.validarFiltroSeleccionado(values);
            } 
        }
    };

    validarFiltroSeleccionado(values: any) {
        const errors = {
            tipoParametro: undefined
        };
        if (values.tipoParametro === undefined) {
            errors.tipoParametro = "Por favor ingrese un parametro para continuar";
            this.setState({ visualizarInput: false });
        }
        return errors;
    }

    validarFiltroTodos(values: any) {
        const errors = {
            tipoParametro: undefined
        };
        if (values.tipoParametro === "ALL") {
            this.setState({ visualizarInput: false });
        }
        return errors;
    }

    validarFiltroDni(values: any) {
        const errors = {
            valor: undefined 
        };
        if (values.tipoParametro === 'DNI_EMPRESA' && !values.valor) {
            errors.valor = "Por favor ingrese un dni para continuar";
        }
        this.setState({ visualizarInput: true });
        return errors;
    }

    validarFiltroTelefono(values: any) {
        const errors = {
            valor: undefined 
        };

        if (values.tipoParametro === 'TELEFONO' && !values.valor) {
            errors.valor = "Por favor ingrese un telefono para continuar";
        }
        this.setState({ visualizarInput: true });
        return errors;
    }
}

export default connect((store: any) => {
    return {
        documentos: R.pathOr([], ["report", "documentos"])(store),
        telefonos: R.pathOr([], ["report", "telefonos"])(store),
        estadoConsulta: R.pathOr([], ["report", "estado"])(store),
        estadoXLS: R.pathOr([], ["report", "estadoXLS"])(store),
        tamanoPagina: R.pathOr(10, ["report", "tamanoPagina"])(store),
        paginaActual: R.pathOr(1, ["report", "paginaActual"])(store),
        paginas: R.pathOr(1, ["report", "paginas"])(store)
    };
})(Consultar);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/parametros/consultar_parametros/componentes/Consultar.tsx